import { useView } from '../../../hooks/useView';
import ViewLayout from '../../layouts/view.layout';
import DetailsView from '../../views/alt-channel-info/details.view';
import MediaView from '../../views/alt-channel-info/media-view';
import MembersView from '../../views/alt-channel-info/members-view';
import { CHANNEL_INFO_VIEW } from '../../views/alt-channel-info/support';

type Props = {
  channelId: string;
  close: Function;
};

export default function ChannelOverviewContainer({ close, channelId }: Props) {
  const [, update] = useView('');
  return (
    <ViewLayout defaultView={CHANNEL_INFO_VIEW.MAIN}>
      <ViewLayout.Option name={CHANNEL_INFO_VIEW.MAIN}>
        <DetailsView id={channelId} close={close} />
      </ViewLayout.Option>
      <ViewLayout.Option name={CHANNEL_INFO_VIEW.MEDIA}>
        <MediaView
          id={channelId}
          close={() => update(CHANNEL_INFO_VIEW.MAIN)}
        />
      </ViewLayout.Option>
      <ViewLayout.Option name={CHANNEL_INFO_VIEW.MEMBERS}>
        <MembersView
          id={channelId}
          close={() => update(CHANNEL_INFO_VIEW.MAIN)}
        />
      </ViewLayout.Option>
    </ViewLayout>
  );
}
